var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSitterInfoNum03(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 20C15.5228 20 20 15.5228 20 10C20 4.47715 15.5228 0 10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20Z",
    fill: "#9F6BFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.64014 11.8502H8.66014C8.68014 12.4202 9.23014 12.8102 9.98014 12.8102C10.7301 12.8102 11.2701 12.3802 11.2601 11.7702C11.2701 11.1502 10.7001 10.7202 9.81014 10.7202H8.99014V9.29023H9.81014C10.5801 9.29023 11.1201 8.88024 11.1201 8.27024C11.1201 7.70024 10.6601 7.29023 9.98014 7.29023C9.28014 7.29023 8.74014 7.69023 8.73014 8.29023H6.81013C6.83013 6.78023 8.17013 5.74023 10.0001 5.74023C11.8301 5.74023 13.0501 6.78023 13.0501 8.17023C13.0501 9.12023 12.3601 9.78023 11.3901 9.93023V9.99023C12.6901 10.1502 13.3801 10.8902 13.3701 11.9502C13.3701 13.4202 11.9601 14.4702 9.98014 14.4702C8.00014 14.4702 6.67014 13.4002 6.65014 11.8802L6.64014 11.8502Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSitterInfoNum03);
export default __webpack_public_path__ + "static/media/sitter_info_num_03.c72214b98fc6bd937e60d5cf91fed8e2.svg";
export { ForwardRef as ReactComponent };